import { Controller, Control, UseFormSetValue, useWatch } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { SmartIntakeDateRangeFilter } from './SmartIntakeDateRangeFilter';
import { SmartIntakeFiltersForm, QuickDatePreset } from './SmartIntakeTypes';

const CONFIDENCE_BAND_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'high', label: 'High' },
  { value: 'partial', label: 'Partial match' },
  { value: 'low', label: 'Low extraction' },
];

interface Props {
  control: Control<SmartIntakeFiltersForm>;
  setValue: UseFormSetValue<SmartIntakeFiltersForm>;
  activePreset: QuickDatePreset | null;
  onPresetChange: (preset: QuickDatePreset) => void;
  uploadedByOptions: string[];
}

export const SmartIntakeFilters = ({ control, setValue, activePreset, onPresetChange, uploadedByOptions }: Props) => {
  const from = useWatch({ control, name: 'from' });
  const to = useWatch({ control, name: 'to' });

  return (
    <Stack direction="row" spacing={2} alignItems="flex-start" flexWrap="wrap">
      <SmartIntakeDateRangeFilter
        control={control}
        setValue={setValue}
        activePreset={activePreset}
        onPresetChange={onPresetChange}
        from={from}
        to={to}
      />

      <Controller
        name="confidenceBand"
        control={control}
        render={({ field }) => (
          <FormControl size="small" sx={{ width: 280 }}>
            <InputLabel>Confidence Score</InputLabel>
            <Select {...field} label="Confidence Score">
              {CONFIDENCE_BAND_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />

      <Controller
        name="uploadedBy"
        control={control}
        render={({ field }) => (
          <FormControl size="small" sx={{ width: 280 }}>
            <InputLabel>Uploaded by</InputLabel>
            <Select {...field} label="Uploaded by">
              <MenuItem value="">All</MenuItem>
              {uploadedByOptions.map(name => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
    </Stack>
  );
};
